import ApiClient from '@afosto/api/ApiClient';

class Shipments {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Cancel shipment
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Cancel a shipment
   * @returns {Promise}
   */
  cancelShipment(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Create shipment
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new shipment to the list
   * @returns {Promise}
   */
  createShipment(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * List shipments
   *
   * @param {Object} options - The additional request options
   * @description Get a list of shipments
   * @returns {Promise}
   */
  listShipments(options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Invoice shipment
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Manually trigger an invoice
   * @returns {Promise}
   */
  triggerShipmentInvoice(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}/invoice`,
      method: 'post',
      ...options,
    });
  }

  /**
   * Update a shipment
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update the shipment method or addressing
   * @returns {Promise}
   */
  updateShipment(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Refresh positions
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Refresh a shipment&#39;s positions to the latest known defaults
   * @returns {Promise}
   */
  updateShipmentPositions(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}/positions`,
      method: 'put',
      ...options,
    });
  }

  /**
   * View a single shipment
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a single shipment
   * @returns {Promise}
   */
  viewShipment(id, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}`,
      method: 'get',
      ...options,
    });
  }
}

export const shipments = new Shipments();

export default Shipments;
